import type { PluginManifest } from "@d12labs/plugins/types";

export const manifest: PluginManifest = {
	name: "fitstreak",
	label: "FitStreak",
	description:
		"Personal training accountability — a unified activity log, a derive-on-read streak engine, GVT strength + mobility logging, gamification, and a daily email nudge.",
	version: "0.1.0",
	navItems: [{ label: "FitStreak", href: "/fitstreak", icon: "Flame" }],
	settings: {
		id: "fitstreak",
		title: "FitStreak",
		icon: "Flame",
		blurb: "The daily activity-streak reminder.",
		rows: [
			{
				key: "FITSTREAK_REMINDER_HOUR",
				label: "FitStreak reminder hour",
				placeholder: "20",
				restartRequired: true,
				help: 'Local hour (0–23) the daily "did you move?" nudge fires. Default 20 (8 PM). Read once at startup when the recurring job is registered — takes effect after a restart.',
			},
		],
	},
};
